interface ICALCULATOR_CARD {
  title: string;
  desc: string;
  image: string | null;
  link: string;
}

export const CalculatorCard = ({
  title,
  desc,
  image,
  link,
}: ICALCULATOR_CARD) => {
  const calcImage =
    image || 'https://assets.clear.in/cleartax/images/1704872079_calcimage.png';

  return (
    <a href={link} target="_blank" rel="noreferrer">
      <div
        className="border border-[#D5E5FC] rounded-md relative cursor-pointer h-72 sm:h-36"
        data-testid="calculator-card"
        style={{
          background: `url(${calcImage})`,
          backgroundPosition: 'bottom right',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '50%',
        }}
      >
        <div className="px-6 pt-6 sm:p-2">
          <div className="text-s-24 font-bold text-font-500 sm:text-base">
            {title}
          </div>
          <div className=" text-base font-medium text-font-200 mt-4 mb-10 w-10/12 third-line-ellipsis overflow-hidden sm:mt-1 sm:text-s-8">
            {desc}
          </div>
        </div>
      </div>
    </a>
  );
};
